<template>
  <v-flex class="sfh-login-header text-xs-center pa-1">

    <v-layout   align-center justify-space-between py-2>
      <div class="d-flex align-center">
        <span class="d-flex ml-3 router-link-active"  to="/">
          <img :src="appIcon"
               @click.stop="$store.commit('toggleLeftDrawer', true)"
               height="40"
               style="cursor:pointer;"
               :alt="appName" />
        </span>
        <span style="font-size: 20px;" class="pl-2">
          <span class="white--text font-weight-regular float-left mt-2 line-height-1"
                style="text-align: left;" v-html="appName" />
          <span v-if="$store.getters.getPageSubTitle"
                class="text-xs-left white--text font-italic" v-text="$store.getters.getPageSubTitle"/>
        </span>
      </div>
      <div>
        <v-list-tile avatar class="user-top-avatar">
          <v-list-tile-avatar>
            <div class="user-avatar elevation-10"
                 :style="{ backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',height:'40px',width:'40px' }"></div>
          </v-list-tile-avatar>
          <v-toolbar-side-icon
            id="cogenti-sfh-logo"
            :class="currentStep === this.levelsCount ? 'current-step':''"
            class="notranslate"  dark  @click.stop="$store.commit('toggleRightDrawer', true)"
          ></v-toolbar-side-icon>
        </v-list-tile>
      </div>
    </v-layout>

    <navigation-menu></navigation-menu>
    <v-navigation-drawer
      temporary
      v-model="leftDrawer"
      app
      class="white"
    >
      <v-layout row text-xs-left>
        <v-flex xs12 vikas style="padding-top: env(safe-area-inset-top)">
          <div>

          <h3 class="font-weight-bold" style="padding:10px;" >Exam Readiness</h3>
          <p style="padding:10px;">
            To enable the exam, you must view the instruction (by reading or playing video) and complete a quiz for each level.
          </p>
            <table class="table table-bordered">
              <tr class="darken-3 grey white--text">
                <th rowspan="2">Level</th>
                <th colspan="2">Instruction</th>
                <th rowspan="2">Quiz</th>
              </tr>
              <tr class="darken-3 grey white--text">
                <th>Read</th>
                <th>Or play video</th>
              </tr>
              <tr v-for="level in reverseLevels" :key="level.name">
                <td
                  :class="(getViewStatus(level.id) || level.memberLevel.videoPlayedAt)
                  && level.memberLevel.latestQuizTime ? 'green lighten-4':'light-blue lighten-4'"
                  style="border:1px solid #fff!important;">{{level.name}}</td>

                <td style="vertical-align: middle;border:1px solid #fff!important;"
                    v-if="getViewStatus(level.id)"
                    class="green lighten-4">
                  <span class="notranslate"><v-icon>done</v-icon></span>
                </td>

                <td style="vertical-align: middle;border:1px solid #fff!important;" v-else
                    :class="(getViewStatus(level.id) || level.memberLevel.videoPlayedAt)
                  && level.memberLevel.latestQuizTime ? 'green lighten-4':'light-blue lighten-4'"
                >
                  &nbsp;
                </td>

                <td style="vertical-align: middle;border:1px solid #fff!important;" v-if="level.memberLevel.videoPlayedAt" class="green lighten-4">
                  <span class="notranslate"><v-icon>done</v-icon></span>
                </td>
                <td style="border:1px solid #fff!important;" v-else
                    :class="(getViewStatus(level.id) || level.memberLevel.videoPlayedAt)
                  && level.memberLevel.latestQuizTime ? 'green lighten-4':'light-blue lighten-4'">
                  &nbsp;
                </td>

                <td style="vertical-align: middle;border:1px solid #fff!important;" v-if="level.memberLevel.learningNeedColor === 3" class="red">
                  <span class="notranslate"><v-icon class="white--text">loop</v-icon>
                  </span>
                </td>
                <td style="vertical-align: middle;border:1px solid #fff!important;" v-else-if="level.memberLevel.latestQuizTime" class="green lighten-4">
                  <span class="notranslate"><v-icon>done</v-icon>
                  </span>
                </td>
                <td style="border:1px solid #fff!important;" v-else class="light-blue lighten-4">
                  &nbsp;
                </td>
              </tr>
            </table>
          </div>
        </v-flex>

      </v-layout>
    </v-navigation-drawer>
  </v-flex>
</template>

<script>
  import NavigationMenu from './NavigationMenu'
  import PlainToolbar from './PlainToolbar'

  function getLevelsViewStatus (data, viewsViewedSet) {
    // Process each level
    return data.map(level => {
      let viewStatus = false
      for (const card of level.cards || []) {
        for (const view of card.views || []) {
          if (viewsViewedSet.includes(view.view_id)) {
            viewStatus = true
            break // Stop checking more views if already found
          }
        }
        if (viewStatus) break // Stop checking more cards if already found
      }

      return {
        level_number: level.level_number,
        view_status: viewStatus
      }
    })
  }

  export default {
    name: 'ProgramLevelsHeader',
    components: {
      NavigationMenu, PlainToolbar
    },
    data () {
      return {
        listGroup: false,
        appIcon: require('@/assets/logos/' + process.env.APP_ICON),
        appName: process.env.APP_NAME,
        appShortName: process.env.APP_SHORT_NAME,
        levelViews: []
      }
    },
    created () {
      if (this.group && this.navigationData && this.navigationData.length > 0 && this.group.viewsViewed) {
        this.calcLevelViewStatus(this.navigationData, this.group.viewsViewed)
      }
    },
    computed: {
      navigationData () {
        return this.$store.getters['learn/getFolders']
      },
      group () {
        return this.$store.getters['course/getGroups'].find(group => group.groupId === this.groupId())
      },
      currentStep: {
        get: function () {
          return this.$store.getters.getTourCurrentStep
        },
        set: function () {
          // setting db object
        }
      },
      leftDrawer: {
        get: function () {
          return this.$store.getters.leftDrawer
        },
        set: function (value) {
          this.$store.commit('toggleLeftDrawer', value)
        }
      },
      levels () {
        return [...this.$store.getters['course/getLevels']]
      },
      reverseLevels () {
        return this.levels.reverse()
      },
      iPad () {
        return this.$store.getters.getIPad
      },
      levelsCount () {
        return this.$store.getters['getLevelsCount']
      }
    },
    methods: {
      getViewStatus (id) {
        if (this.levelViews) {
          const a = this.levelViews.find(x => x.level_number === id)
          if (!a || typeof a.view_status === 'undefined') {
            return false
          }
          return a.view_status
        }
        return false
      },
      calcLevelViewStatus () {
        if (this.group && this.navigationData && this.navigationData.length > 0 && this.group.viewsViewed) {
          this.levelViews = getLevelsViewStatus(this.navigationData, this.group.viewsViewed)
        }
      },
      groupId () {
        return typeof this.$route.params.groupId !== 'undefined'
          ? parseInt(this.$route.params.groupId) : parseInt(this.groups[0].groupId)
      }
    },
    watch: {
      group () {
        this.calcLevelViewStatus()
      },
      navigationData () {
        this.calcLevelViewStatus()
      }
    }
  }
</script>
<style scoped>
  .left_nav .v-list__group__header .v-list__group__header__prepend-icon{
    display: none!important;
  }
</style>
<style>
.user-top-avatar .v-list__tile{
  padding: 0 !important;
  justify-content: end;
}
.user-top-avatar .v-list__tile__avatar {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/ProgramLevelsHeader.vue